<template>
  <el-menu router unique-opened :default-active="activeMenu" :collapse="isCollapse" background-color="#0e1631"
    text-color="#bfcbd9" active-text-color="#409EFF">
    <template v-for="item of menus">
      <el-submenu v-if="item.childNode && item.childNode.length" :key="item.menuId" :index="item.url">
        <template slot="title">
          <i class="iconfont" :class="item.iconPath"></i>
          <span>{{ item.menuName }}</span>
        </template>
        <template v-for="child2 of item.childNode">
          <el-submenu v-if="child2.childNode && child2.childNode.length" :index="child2.url" :key="child2.url">
            <template slot="title">
              <i class="iconfont" :class="child2.iconPath"></i>
              <span>{{ child2.menuName }}</span>
            </template>
            <el-menu-item v-for="child3 of child2.childNode" :index="child3.url" :key="child3.menuId">
              <!-- <i class="iconfont child-icon" :class="child.iconPath"></i> -->
              <span>{{ child3.menuName }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :index="child2.url" :key="child2.menuId">
            <!-- <i class="iconfont child-icon" :class="child.iconPath"></i> -->
            <span>{{ child2.menuName }}</span>
          </el-menu-item>
        </template>
      </el-submenu>
      <el-menu-item v-else :index="item.url" :key="item.menuId">
        <i class="iconfont" :class="item.iconPath"></i>
        <span slot="title">{{ item.menuName }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    activeMenu() {
      const { meta, fullPath } = this.$route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return fullPath
    },
    menus() {
      return this.$store.state.menus
    }
  },
  created() {
    this.$store.dispatch('loadUserMenus')
  },
  methods: {
  }
}
</script>

<style scoped lang='scss'>
.iconfont {
  font-weight: bold;
  font-size: 16px;
  margin-right: 8px;
}

.el-menu {
  width: 200px;
  border-right: 0;

  ::v-deep {
    .el-submenu {
      .el-menu-item {
        background-color: #202844 !important;
      }
    }

    &.is-active {
      background: linear-gradient(270deg, #06CED4 0%, #0A9DD5 49%, #0E6AD7 100%) !important;
      color: #ffffff !important;
    }
  }

  ::v-deep .el-menu-item:hover {
    background-color: #0A9DD5 !important;
  }

  ::v-deep .el-submenu__title i {
    color: #bfcbd9;
  }

  ::v-deep .el-menu--inline {
    background-color: rgb(38, 52, 69) !important;
  }

  .child-icon {
    font-size: 14px;
    margin-right: 5px;
  }
}
</style>
